import Tooltip, { TooltipTrigger } from '@orn/shared-web/components/Tooltip/Tooltip';
import { cx } from '@orn/shared-web/utils/cx';
import formatDateTime from '@orn/shared-web/utils/datetime/formatDateTime';
import formatTimeAgo from '@orn/shared-web/utils/datetime/formatTimeAgo';

interface ISyncStatusProps {
  className?: string;
  lastSyncedAt?: string | null;
  addPrefix?: boolean;
  size?: 'sm' | 'xs';
}

/** Colored dot + relative time label showing how recently a bank connection last synced. */
const SyncStatus = ({ className, lastSyncedAt, addPrefix, size = 'sm' }: ISyncStatusProps) => {
  const syncStatusText = lastSyncedAt ? formatTimeAgo(lastSyncedAt) : 'n/a';
  const tooltipText = lastSyncedAt ? formatDateTime(lastSyncedAt) : 'Never synced';

  let bubbleColorClass = 'bg-fg-success-secondary';
  if (!lastSyncedAt) {
    bubbleColorClass = 'bg-fg-quaternary';
  } else {
    const date = new Date(lastSyncedAt);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays >= 14) {
      bubbleColorClass = 'bg-error-solid';
    } else if (diffDays >= 7) {
      bubbleColorClass = 'bg-warning-solid';
    }
  }

  const isXs = size === 'xs';
  const textSizeClass = isXs ? 'text-xs' : 'text-sm';
  const dotSizeClass = isXs ? 'size-1.5' : 'size-2';

  return (
    <Tooltip title={tooltipText}>
      <TooltipTrigger className={className}>
        <div className="flex items-center gap-1">
          <div className={cx('shrink-0 rounded-full', dotSizeClass, bubbleColorClass)} />
          <div className={cx('text-tertiary font-medium', textSizeClass)}>
            {addPrefix && <span>Last sync: </span>}
            <span>{syncStatusText}</span>
          </div>
        </div>
      </TooltipTrigger>
    </Tooltip>
  );
};

export default SyncStatus;
